import Analytics from "analytics";
import simpleAnalyticsPlugin from "@analytics/simple-analytics";

const plugins = [];

if (process.env.NODE_ENV === "production") {
  plugins.push(
    simpleAnalyticsPlugin({
      collectDnt: true,
      autoCollect: false,
      allowParams: [
        "area",
        "type",
        "completion",
        "numberOfBedrooms",
        "amenities",
        "priceMin",
        "priceMax",
        "isPaymentPlanPostHandover",
        "isHighRoi",
        "isHighCapitalAppreciation",
        "developer",
        "currency",
      ].join(","),
    }),
  );
}

const analytics = Analytics({
  app: "insidedubaiestate",
  plugins,
  debug: true,
});

export default analytics;
